import Vue from 'vue';
import VueRouter from 'vue-router'

import WordComponent from './components/FindWords/WordComponent.vue'
import HomeComponent from './components/Home/Home.vue'
import WorkComponent from './components/Projects/Projects.vue'
import ProjectInfo from './components/Projects/projectInfo.vue'
import BlogComponent from './components/Blog/Blog.vue'
import BlogPost from './components/Blog/BlogPost.vue'
import BlogNav from './components/Blog/BlogNav.vue'

Vue.use(VueRouter);

export const routes = [
    { path: '', component: HomeComponent},
    { path: '/findwords',  component: WordComponent},
    { path: '/projects', component: WorkComponent},
    { path: '/projects/:id', component: ProjectInfo},
    { path: '/blog', component: BlogComponent},
    { path: '/blog/:id', component: BlogPost, children: [
        { path: '', component: BlogNav }
    ]},
];

export default new VueRouter({
    mode: 'history', 
    routes, 
    scrollBehavior(to, from, savedPosition) {
        if(savedPosition){ return savedPosition;}
        if(to.hash){ return { selector: to.hash };}
        return {x: 0, y: 0};
    }
})